import React, { useState } from 'react';
import { Col, Container, Row, Form, Button, Modal } from 'react-bootstrap';
import CSSLoader from '../../../../shared/cssLoader/index';
import InterviewEventConfiguration from './meetingConfiguration';
import Review from './review';
import styles from './shareExternalMeetingDetailsModal.module.scss';
import { CustomAlertBox } from '../../../../shared/customAlertBox';

const ShareExternalMeetingDetailsModal = (props) => {

    let [step, setStep] = useState(1);
    let [values, setValues] = useState({
        session_id: props.externalMeetingModalData.session_id,
        externalMeetingURL: '',
        description: '',

    });
    let [isLoading, setLoading] = useState(false);


    function nextPage(value) {
        setStep(value)
    }

    function previousPage(value) {
        setStep(value)
    }

    function setSubmitValues(values) {
        setValues((prevState) => ({
            ...prevState,
            externalMeetingURL: values.externalMeetingURL,
            description: values.description,
        }))
    }

    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Alternative Online Meeting Tools</h2>
                    </div>



                    <Col className={styles.CustomAlertBoxWrap}>
                        <CustomAlertBox
                            alertBodyText="If you face any issues when using inbuilt video meeting feature, use this option to share an external meeting URL (Google Meets / Microsoft Teams / Zoom) to conduct the interview. Once you fill this and submit, the candidate and interviewers will receive email notifications with the update."
                            alertType="defaultAlert"
                        />
                    </Col>


                    <Col sm={12} className="mb-4">
                        <Container>
                            <p className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'External Meeting Details'
                                        : 'Review External Meeting Details '
                                }
                            </p>
                        </Container>
                    </Col>

                    <Col sm={12}>


                        {
                            isLoading === false ?
                                (<Container>
                                    {/* Rendering Content Goes Here */}
                                    {step === 1 && props.showModal === true && <InterviewEventConfiguration externalMeetingModalData={props.externalMeetingModalData} nextPage={nextPage} setSubmitValues={setSubmitValues} values={values}

                                    />}
                                    {step === 2 && props.showModal === true && <Review externalMeetingModalData={props.externalMeetingModalData} nextPage={nextPage} previousPage={previousPage} handleClose={props.handleClose}
                                        values={values}
                                    />}
                                </Container>)
                                : (<div>
                                    <Col sm={{ span: 4, offset: 4 }}>
                                        <CSSLoader />
                                    </Col>
                                </div>)
                        }
                    </Col>


                </Modal.Body>

            </Modal>

        </div >
    )
}

export default ShareExternalMeetingDetailsModal